import { ToggleSetting } from '.'
import { UserSettingsSection } from './UserSettingsSection'

export const Reminders = () => {
  const rows = [
    {
      label: 'New App Version',
      cells: [<ToggleSetting key="appVersionReminder" settingKey="appVersionReminder" />]
    }
  ]

  return <UserSettingsSection header="Reminders" rows={rows} />
}
